import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import Button from '../../Button';
import { LocalizationContext } from '../../../hoc/Localization';
import { SettingsContext } from '../../../hoc/Settings';
import { LocationContext } from '../../../hoc/Location';
import styles from './styles.less';

const renderButton = (onClick, link) => {
  const { t } = React.useContext(LocalizationContext);
  if (!onClick) {
    if (link) {
      return (
        <a href={link} target="_blank" rel="noopener noreferrer">
          <Button type="primary" version="large">
            {t('landing.join.button')}
          </Button>
        </a>
      );
    }
    return (
      <Button type="primary" version="large">
        {t('landing.join.button')}
      </Button>
    );
  }
  return (
    <Button onClick={onClick} type="primary" version="large">
      {t('messenger.take.test')}
    </Button>
  );
};

const Card = ({ title, description, image, bgColor, onClick, small, link, bgImage }) => (
  <div className={styles.container} style={{ backgroundColor: bgColor }}>
    <div>
      <h2>{title}</h2>
    </div>
    <div>
      <p style={{ fontSize: small ? '18px' : '24px', lineHeight: small ? '28px' : '54px' }}>
        {description}
      </p>
    </div>
    <div>{renderButton(onClick, link)}</div>
    <div className={styles.imageContainer}>
      <img src={image} alt={title} />
    </div>
    <img className={styles.backgrund} src={bgImage} alt="" />
  </div>
);

Card.propTypes = {
  small: PropTypes.bool,
  link: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  bgColor: PropTypes.string.isRequired,
  bgImage: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

Card.defaultProps = {
  link: '',
  small: false,
  onClick: null,
};

const JoinGroup = ({ category }) => {
  const { t, translate } = React.useContext(LocalizationContext);
  const { countries } = React.useContext(LocationContext);
  const {
    domainSettings: {
      facebook: { testLink },
    },
  } = React.useContext(SettingsContext);

  const takeTest = () => {
    window.open(testLink);
  };

  return (
    <div>
      <Row gutter={20} type="flex">
        <Col className={styles.col} md={12} xs={24}>
          <Card
            title={t('messenger.title')}
            description={t('messenger.subtitle')}
            image="/static/images/frontpage/messenger.svg"
            bgColor="#fe678a"
            onClick={takeTest}
            bgImage="/static/images/subLanding/bg_illustration_pink.png"
          />
        </Col>
        <Col className={styles.col} md={12} xs={24}>
          <Card
            title={t('landing.join.title')}
            description={translate(category, 'join_text')}
            image="/static/images/subLanding/discount.svg"
            bgColor="#67297c"
            small
            link={category[`join_link_${countries[0]}`]}
            bgImage="/static/images/subLanding/bg_illustration_purple@3x.png"
          />
        </Col>
      </Row>
    </div>
  );
};

JoinGroup.propTypes = {
  category: PropTypes.object.isRequired,
};

export default JoinGroup;
